// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search[data-v-4358ae2b] {\n  max-width: 40rem;\n  margin: 0 1rem 0 0;\n}\n.filter--container[data-v-4358ae2b] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
